import React from 'react';
import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

export const containerStyles = css`
  background-color: #3b54de;
`;

export const getQuizDetailsBackground = () => {
  return <Box className={cn(containerStyles, 'relative h-full w-full')} />;
};
